import { useOmniOfferShowQuery } from "@/services/backend/omni/offer/api/offer-api";
import { OfferPricingPage } from "@/services/backend/omni/offer/components/offer-pricing-page";
import { CardSkeleton } from "@/shared/components/card-skeleton";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { useParams } from "react-router";

export function OfferPricingRoute() {
  const { offerId } = useParams();

  const { data, isLoading, error } = useOmniOfferShowQuery({
    id: offerId!,
  });

  return (
    <div>
      {error && <RTKQueryErrorAlert error={error} />}
      {isLoading && <CardSkeleton />}
      {data && <OfferPricingPage offer={data} />}
    </div>
  );
}
